<div id="lista" class="page-layout carded fullwidth">
    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">
        <!-- HEADER -->
        <div
            class="header accent"
            fxLayout="column"
            fxLayoutAlign="center center"
            fxLayout.gt-sm="row"
            fxLayoutAlign.gt-sm="space-between center"
        >
            <!-- TÍTULO E BOTÕES ALINHADOS -->
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="nogrow">
                <!-- TÍTULO -->
                <div class="logo mb-24 mb-md-0" fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon class="logo-icon s-32 mr-16"> business </mat-icon>
                    <span class="logo-text h1"> Boleta de Consórcio </span>
                </div>
                <!-- / TÍTULO -->

                <!-- BOTÕES DE AÇÃO -->
                <div fxLayout="row" fxLayoutAlign="start center" style="margin-left: 16px; gap: 8px">
                    <!-- Botão Consultar -->
                    <button
                        mat-mini-fab
                        [color]="hasActiveFilters ? 'warn' : 'accent'"
                        [matTooltip]="hasActiveFilters ? 'Filtros ativos: ' + activeFiltersCount : 'Consultar Boleta'"
                        (click)="openFiltro()"
                    >
                        <mat-icon>search</mat-icon>
                    </button>

                    <!-- Botão Exportar -->
                    <button mat-mini-fab color="accent" matTooltip="Exportar Boletas" (click)="export()">
                        <mat-icon>cloud_download</mat-icon>
                    </button>

                    <!-- Botão Cadastrar Cliente -->
                    <button mat-mini-fab color="accent" matTooltip="Cadastrar Novo Cliente" (click)="cadastroCliente()">
                        <mat-icon>person_add</mat-icon>
                    </button>

                    <!-- Botão Nova Boleta -->
                    <button
                        mat-mini-fab
                        color="accent"
                        matTooltip="Nova Boleta"
                        [routerLink]="'/consorcio/cadastrar-boleta-consorcio'"
                    >
                        <mat-icon>add_circle</mat-icon>
                    </button>
                </div>
                <!-- / BOTÕES DE AÇÃO -->
            </div>
            <!-- / TÍTULO E BOTÕES ALINHADOS -->
        </div>
        <!-- / HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">
            <!-- Loading Indicator -->
            <div *ngIf="loadingIndicator" class="loading-container p-16" style="text-align: center">
                <mat-spinner diameter="30"></mat-spinner>
                <span style="margin-left: 8px" data-testid="loading-indicator">Carregando...</span>
            </div>
            <ngx-datatable
                #table
                class="material striped"
                [columns]="columns"
                [columnMode]="'force'"
                [headerHeight]="50"
                [footerHeight]="50"
                [rowHeight]="'auto'"
                (sort)="onSort($event)"
                [rows]="rows"
                [messages]="{
                    emptyMessage: 'Nenhuma boleta de consórcio encontrada',
                }"
            >
                <ngx-datatable-column name="Código" prop="id" [sortable]="true" [width]="100">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        {{ row.id }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Data Atualização" prop="updated_at" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-updated_at="value" ngx-datatable-cell-template>
                        {{ updated_at | date: "dd/MM/yyyy HH:mm" }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Cliente" prop="cliente" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-cliente="value" ngx-datatable-cell-template>
                        {{ cliente.numero_xp != null ? cliente.numero_xp + " - " + cliente.nome : cliente.nome }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column
                    name="Escritório/Assessor"
                    prop="cliente"
                    [sortable]="false"
                    *ngIf="this.user.role_id != 5"
                >
                    <ng-template let-rowIndex="rowIndex" let-cliente="value" ngx-datatable-cell-template>
                        {{ cliente.assessor.escritorio_padrao?.nome_fantasia }}
                        <br />
                        {{ cliente.assessor?.name }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Status Boleta" prop="status" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-status="value" ngx-datatable-cell-template>
                        {{ status.nome }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Parceiro" prop="parceiro_consorcio" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-parceiro_consorcio="value" ngx-datatable-cell-template>
                        {{ parceiro_consorcio.nome }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Tipo de operação" prop="tipo_consorcio" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-tipo_consorcio="value" ngx-datatable-cell-template>
                        {{ tipo_consorcio.nome }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Valor (R$)" prop="valor" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-valor="value" ngx-datatable-cell-template>
                        R${{ valor | number: "1.2-2" }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Data Retorno" prop="data_retorno" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-data_retorno="value" ngx-datatable-cell-template>
                        {{ data_retorno | date: "dd/MM/yyyy" }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Data Assembleia" prop="data_assembleia" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-data_assembleia="value" ngx-datatable-cell-template>
                        {{ data_assembleia | date: "dd/MM/yyyy" }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Lance Recorrente?" prop="is_recorrente" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-is_recorrente="value" ngx-datatable-cell-template>
                        {{ isRecorrente(is_recorrente) }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Lance Livre/Fixo" prop="is_fixo_livre" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-is_fixo_livre="value" ngx-datatable-cell-template>
                        {{ is_fixo_livre ? is_fixo_livre : "" }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Ação" prop="id" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        <button mat-icon-button [matMenuTriggerFor]="actions" matTooltip="Mostrar Opções">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #actions="matMenu">
                            <button
                                mat-menu-item
                                matTooltip="Visualizar Boleta"
                                [routerLink]="'/consorcio/visualizar-boleta-consorcio/' + row.id"
                            >
                                <mat-icon aria-label="Visualizar Boleta">search</mat-icon>
                                VISUALIZAR
                            </button>
                            <button
                                mat-menu-item
                                matTooltip="Editar Boleta"
                                [routerLink]="'/consorcio/editar-boleta-consorcio/' + row.id"
                            >
                                <mat-icon aria-label="Editar Boleta">edit</mat-icon>
                                EDITAR BOLETA
                            </button>
                            <button mat-menu-item matTooltip="Exportar Cartas" (click)="cartasExport(row.id)">
                                <mat-icon aria-label="Exportar Cartas">cloud_download</mat-icon>
                                EXPORTAR CARTAS
                            </button>
                            <button mat-menu-item matTooltip="Excluir Boleta" (click)="delete(row.id)">
                                <mat-icon aria-label="Excluir Boleta">delete</mat-icon>
                                EXCLUIR BOLETA
                            </button>
                        </mat-menu>
                    </ng-template>
                </ngx-datatable-column>
            </ngx-datatable>

            <div style="padding: 5px 10px">
                <mat-paginator
                    #paginator
                    [length]="length"
                    [pageSize]="pageSize"
                    [pageSizeOptions]="pageSizeOptions"
                    (page)="pageEvent($event)"
                >
                </mat-paginator>
            </div>
        </div>
    </div>
</div>
